import { ENTRIES_LOADED } from '../constants';

export default function update(state = {byId:{}, all:[], byTitle:{}}, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.contrarianPage) {
                let result = {byId:{}, all:[], byTitle:{}}
                Object.keys(action.entries.contrarianPage).forEach(k => {
                    let it = action.entries.contrarianPage[k]
                    if (it && it._id) {
                        result.byId[it._id] = it
                        result.byTitle[it.title] = it
                        result.all.push(it)
                    }
                })
                return result
            }
            break;
    }
    return state;
}
